import CommsFrame from './CommsShell'
import { StatusBadge } from '../operations'

/**
 * RoleDetail — /square/command-center/team/roles/:id.
 *
 * PHASE_2I: custom team roles (sq_team_roles) are DEFERRED. v1 uses a fixed
 * role enum on sq_team_members. This surface says so honestly — it never
 * fabricates a roles catalogue.
 *
 * Chat #2 conversion: presentation lives in comms-surface.css; no hex/inline
 * color literals remain.
 */
export interface RoleDetailProps {
  roleId?: string
  onHome?: () => void
  onBackCommandCenter?: () => void
  onBackTeam?: () => void
  onNavTop?: (to: string) => void
}

const ENUM_ROLES: Array<{ id: string; note: string }> = [
  { id: 'owner', note: 'Full control of the team + comms.' },
  { id: 'admin', note: 'Manage members and channels.' },
  { id: 'member', note: 'Participate in channels and tasks.' },
  { id: 'viewer', note: 'Read-only access.' },
]

export default function RoleDetail({ roleId, onHome, onBackCommandCenter, onBackTeam, onNavTop }: RoleDetailProps) {
  const active = ENUM_ROLES.find((r) => r.id === (roleId || '').toLowerCase())
  const center = (
    <div className="sqv-surface-comms" style={{ gap: 14 }}>
      <div className="sqv-comms-card">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
          <h3 className="sqv-comms-title sqv-comms-title-flush">Custom team roles</h3>
          <StatusBadge status="BACKEND_DEFERRED" size="sm" />
        </div>
        <p className="sqv-comms-m0 sqv-comms-c-3" style={{ fontSize: 12.5, lineHeight: 1.7 }}>
          Operator-created custom roles (a `sq_team_roles` table + assignment UI) are not built in v1 — the backend is not ready yet. The team uses the fixed roles below on the roster. No roles catalogue is fabricated here.
        </p>
      </div>
      <div className="sqv-comms-card">
        <h3 className="sqv-comms-title">v1 fixed roles</h3>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
          {ENUM_ROLES.map((r) => (
            <div key={r.id} className="sqv-comms-tile" data-active={active?.id === r.id ? 'true' : 'false'} style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
              <span className="sqv-comms-rolebadge">{r.id.toUpperCase()}</span>
              <span className="sqv-comms-c-2" style={{ fontSize: 12.5 }}>{r.note}</span>
            </div>
          ))}
        </div>
      </div>
      <button type="button" onClick={onBackTeam} className="sqv-comms-btn" style={{ alignSelf: 'flex-start' }}>← Team</button>
    </div>
  )
  return (
    <CommsFrame
      activeTop="team"
      surface="team-roles"
      breadcrumb={['COMMAND CENTER', 'TEAM', 'ROLES', (roleId || 'DETAIL').toUpperCase()]}
      title="Roles"
      onHome={onHome}
      onBackCommandCenter={onBackCommandCenter}
      onNavTop={onNavTop}
      center={center}
    />
  )
}
